import { render } from "./SearchSubmissionInput.vue?vue&type=template&id=0f7707d6"
import script from "./SearchSubmissionInput.vue?vue&type=script&lang=ts"
export * from "./SearchSubmissionInput.vue?vue&type=script&lang=ts"
script.render = render
/* custom blocks */
import block0 from "./SearchSubmissionInput.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(script)


export default script